(function() {
    const isDebug = true;
    const isTesting = false;

    const baseStyles = [
      "color: #fff",
      "background-color: #2759e1",
      "padding: 2px 8px",
      "border-radius: 4px",
    ].join(";");
    function consoleLog() {
      if (window.console && isDebug === true) {
        console.log("%cNP-CUSTOM-IPAPI", baseStyles, ...Array.prototype.slice.call(arguments));
      }
    }
    
    var fullUrl = window.location.href;
    var urlAfterDomain = window.location.pathname;
    var segments = urlAfterDomain.split('/');
    var productURL = segments[2];  
    var articleURL = segments[3]; 

    function regionalTextUpdatesARPA() { 
        consoleLog('Calling regionalTextUpdatesARPA()');
        $('.as-directed').text(', when used as directed'); 
            $('.product__title h1').text('NATPAT Tick Repellent Stickers for Pets');
        $('#OurTrailPatch img.lp-tr--desktop ').attr('src', '//www.natpat.com/cdn/shop/files/lp-pet-tick-repellent--compare-wi_1096x.png?v=17881194414520063509');
        $('#OurTrailPatch img.lp-tr--mobile ').attr('src', '//www.natpat.com/cdn/shop/files/lp-pet-tick-repellent--compare-mb-wi_648x.png?v=3070993649646052290'); 
    } 
    function regionalTextUpdatesWI() { 
        consoleLog('Calling regionalTextUpdatesWI()');
        $('.as-directed-wi').text(', when used as directed');  
        $('.repellents-wi').text('repellents');  
        $('.ingredients-wi').text('ingredients');  
        $('.lp-tr--desktop.chart-wi').attr('src', '//www.natpat.com/cdn/shop/files/lp-pet-tick-repellent--compare-wi_1096x.png?v=17881194414520063509');
        $('.lp-tr--mobile.chart-wi').attr('src', '//www.natpat.com/cdn/shop/files/lp-pet-tick-repellent--compare-mb-wi_648x.png?v=3070993649646052290'); 
    } 

    async function checkIPAPI() {
        consoleLog('Calling checkIPAPI()');
        
    }

    async function checkLocation() {
        consoleLog('Calling checkLocation()');
        try {
            let checkUrl = 'https://ipapi.natpat.com/';
            const response = await fetch(checkUrl);
            if (!response.ok) {
            console.error('Error fetching JSON data:', response);
            return;
            }
            const jsonData = await response.json();
            consoleLog('Fetched JSON data:', jsonData);

            // Gather all region/state values from stateConfidence and loc
            const stateRegions = [
                ...(Array.isArray(jsonData?.stateConfidence) ? jsonData.stateConfidence.map(sc => sc.region) : [])
            ].filter(Boolean);

            if (stateRegions.length === 0) {
                consoleLog('No user state found');
                return;
            }
            consoleLog('User state found:', stateRegions);

            if (stateRegions.includes('Arizona')) { 
                $('.content-hidden').hide(); 
                $('.deet-claim').show(); 
                if (productURL === 'trailpatch-pet-tick-repellent-stickers'  || productURL === 'trailpatch-pet') { 
                    regionalTextUpdatesARPA() 
                }
            }  
            if (stateRegions.includes('Wisconsin')  ) { 
                $('.deet-claim').show();  
                $('.content-hidden-wi').hide();   
                regionalTextUpdatesWI() 
            } 
        } catch (error) {
            console.error('Error fetching JSON data:', error);
        }
    }

    async function regionBasedUpdate() {
        consoleLog('Calling regionBasedUpdate()');
        var userCountry = Shopify && Shopify.country ? Shopify.country : '';  
        if (userCountry === 'US') { 
            await checkLocation();
            // await checkIPAPI();
        } else {
            consoleLog('You are from other country: ' + userCountry);
        } 
    }
    regionBasedUpdate();
})();